import { createContext, useContext } from "react";
import { useLocalObservable } from "mobx-react-lite";

import { SkillCollectionEditorStore } from "./skill-collection-editor-store";

const SkillCollectionEditorContext = createContext<SkillCollectionEditorStore | null>(null);

export const SkillCollectionEditorProvider = ({ children }: { children: React.ReactNode }) => {
  const store = useLocalObservable(() => new SkillCollectionEditorStore());

  return (
    <SkillCollectionEditorContext.Provider value={store}>
      {children}
    </SkillCollectionEditorContext.Provider>
  );
};

export const useSkillCollectionEditorStore = () => {
  const store = useContext(SkillCollectionEditorContext);

  if (!store) {
    throw new Error(
      "useSkillCollectionEditorStore must be used within SkillCollectionEditorProvider",
    );
  }

  return store;
};
